module.exports = "https://www.gc-qa.gnp.com.mx/6cded7af70fabe103afda93ba0a81fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/editar-icono.png
// module id = 325
// module chunks = 0